<template>
  <EhouseCalculatingList />
</template>

<script>
import EhouseCalculatingList from "@/components/Calculatings/EhouseCalculating/List.vue";
export default {
  components: { EhouseCalculatingList },
};
</script>

<style></style>
